import { MapPin, Clock } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Eventos({ datos, seccion }) {
  const eventos = datos.eventos || [];
  if (eventos.length === 0) return null;

  return (
    <section className="qn-seccion" aria-label={seccion.titulo}>
      <div className="qn-seccion-interior">
        <EncabezadoSeccion p="qn" etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid="qn-titulo-eventos" />
        <div className="qn-eventos-lista">
          {eventos.map((ev, i) => (
            <Reveal key={ev.id || i} delay={i * 0.08}>
              <article className="qn-evento" data-testid={`qn-evento-${ev.id || i}`}>
                <p className="qn-evento-etiqueta">{ev.etiqueta}</p>
                <h3 className="qn-evento-nombre">{ev.lugar}</h3>
                <p className="qn-evento-detalle">
                  <Clock strokeWidth={1.5} />
                  <span>{ev.horario}</span>
                </p>
                <p className="qn-evento-detalle">
                  <MapPin strokeWidth={1.5} />
                  <span>{ev.direccion}</span>
                </p>
                {ev.urlUbicacion && (
                  <a
                    className="qn-boton"
                    href={ev.urlUbicacion}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`qn-boton-ubicacion-${ev.id || i}`}
                  >
                    <MapPin strokeWidth={1.5} />
                    {ev.textoBoton || "Cómo llegar"}
                  </a>
                )}
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
